import * as _ from "lodash";
import {
  CUSTOMERS_TREE,
  PRODUCTS_TREE,
  SITE_TREE,
  TYPE_COUNTRY,
  TYPE_SITE,
} from "../Constants";
import * as Models from "../Models";

export const toggleItems: Function = (
  filterItems: any,
  items: string[],
  newState: boolean,
  toggle: boolean = false
): any => {
  return _.keyBy(
    Object.keys(filterItems).map((id: string, index: Number) => {
      const founded: string = _.find(items, (i: string) => i === id);
      let item: Models.DetailBaseData = filterItems[id];

      if (founded) {
        if (toggle) {
          item.showChildren = !item.showChildren;
        } else {
          item.showChildren = newState;
        }
      }

      return item;
    }),
    "id"
  );
};

export const fetchFilters: Function = (filter: string) => {
  let url: string = undefined;

  if (filter === SITE_TREE) {
    url = "/api/countries";
  } else if (filter === CUSTOMERS_TREE) {
    url = "/api/customers";
  } else if (filter === PRODUCTS_TREE) {
    url = "/api/producttypes";
  } else {
    url = `/api/${filter}`;
  }

  // const result: Models.DetailBaseDataCollection = await dispatch(
  // getFilterData(url);
  // );

  // if (filter === SITE_TREE) {
  //   await dispatch(insertCountries(result.items.map((i) => i.name)));
  // } else if (filter === PRODUCTS_TREE) {
  //   await dispatch(insertProductTypes(result.items.map((i) => i.name)));
  // }

  // return result;
  return url;
};

export const getToggleButtonActive: Function = (
  filterItems: Models.DetailBaseData[],
  params: Models.UrlParams
) => {
  let active: boolean = true;
  let details: Models.DetailBaseData = _.find(
    filterItems,
    (i: Models.DetailBaseData) => i.id === params.parameter
  );

  if (!details || details.type === undefined) {
    return false;
  }

  if (
    details.type === "" ||
    details.type === TYPE_COUNTRY ||
    details.type === TYPE_SITE ||
    details.type === CUSTOMERS_TREE ||
    details.type === PRODUCTS_TREE
  ) {
    return false;
  }

  return true;
};

// export const handleConnectivityIssue: Function = (request: Models.AzureRequest, store: Store<any>) => {
//     const state: Models.StateRoot = store.getState();
//     const requests: Models.AzureRequest[] = state.azure.requests;

//     if (requests.find(r => r.url === request.url)) {
//         store.dispatch(AzureActions.connectionIssueUpdate(true));

//         const appInsightsEvent: any = {
//             url: request.url,
//             timestamp: request.started,
//             critical: request.critical
//         };

//         AppInsights.trackEvent('Slow request', appInsightsEvent);
//     }
// }
